export default "__VITE_ASSET__Bwzw7PtD__"